@if (visible) {
  <button
    type="button"
    class="chart-import-chip"
    [class.chart-import-chip-done]="!state.running()"
    data-test-id="chart-import-indicator"
    (click)="dialogOpen.set(true)"
  >
    @if (state.running()) {
      <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      <span>{{ 'humanDesign.chartManager.import.indicator.running' | transloco: { done: state.progressDone(), total: state.progressTotal() } }}</span>
    } @else {
      <i class="fas fa-check" aria-hidden="true"></i>
      <span>{{ 'humanDesign.chartManager.import.indicator.done' | transloco }}</span>
    }
  </button>
}

<!-- Buiten de @if: het rapport dooft de chip (gezien = geen badge meer), maar de
     open dialog moet dan gewoon blijven staan. -->
<e-dialog size="lg" [title]="'humanDesign.chartManager.import.title' | transloco" [(open)]="dialogOpen">
  <ng-template>
    @defer (when dialogOpen(); prefetch on idle) {
      <hd-chart-import-panel />
    }
  </ng-template>
</e-dialog>
